import React, { useCallback } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { CircularProgress } from '@material-ui/core'
import { toast } from 'react-toastify'
import { isAuthenticated } from '../../helpers'

import TournamentDoesnotExistModal from './modal/noTournament'
import Button from '../UI/buttons/buttons-login_register/button/Button'
import CupTab from '../CupTab'

import {
  useTournamentData,
  useUserData,
  useUserParticipation,
  useGameManagement,
  useTournamentNavigation,
} from './hooks'

import styles from './styles.module.scss'

export function Top({ tournamentDoesnotExistModal, tournament }) {
  const { id } = useParams()

  const { userData, requestSuccess } = useUserData()
  const tournamentData = useTournamentData(tournament)
  const participation = useUserParticipation(
    tournament,
    userData,
    requestSuccess
  )
  const gameManagement = useGameManagement(tournament)
  const navigation = useTournamentNavigation(tournament, id)

  const showErrorToast = useCallback(() => {
    toast.error(participation.errorMessage)
  }, [participation.errorMessage])

  const handleRegistrationClick = useCallback(() => {
    participation.checkParticipationTypeData(
      tournament?.participationType,
      navigation.goToUrl
    )
  }, [participation, tournament?.participationType, navigation.goToUrl])

  return (
    <>
      <div className={styles.top}>
        <div
          className={styles.topBanner}
          style={{ '--banner-bg': tournamentData.bannerBackground }}
        >
          <div className={styles.body}>
            <div />
            <img
              src={tournamentData.tournamentLogo}
              alt='logo'
              className={classNames(styles.cP, styles.tournamentLogo)}
            />
          </div>
        </div>
        <div className={classNames(styles.news, styles.cupTopBg)}>
          <div>
            <h2>{tournamentData.tournamentName}</h2> <br />{' '}
            <h3>{tournamentData.tournamentLayer}</h3>
            {tournamentData.tournamentDateRange} {tournamentData.tournamentInfo}
            {!isAuthenticated() && (
              <h3 className={styles.loginMessage}>
                <FormattedMessage id='navigation.login' />
              </h3>
            )}
          </div>

          <div className={styles.statusDisplay}>
            <span className={styles.statusLabel}>
              <FormattedMessage id='game.tournaments.table.status' />
            </span>
            <span className={styles.statusValue}>
              {tournamentData.tournamentStatus}
            </span>
          </div>
        </div>
        <div className={styles.button}>
          <article className={styles.eventsButtonsAndStatic}>
            {!!tournament?.event && (
              <div
                className={styles.eventsButton}
                onClick={navigation.handleEventClick}
              >
                <h1 className={styles.eventsButtonText}>
                  <FormattedMessage id='createTournament.title.titleEvent' />
                </h1>
              </div>
            )}

            {isAuthenticated() ? (
              requestSuccess ? (
                participation.isUserRegistered ? (
                  <section className={styles.btnWrapper}>
                    <div>
                      <Button color='yellow' type='cupbottom'>
                        You already registered
                      </Button>
                    </div>
                  </section>
                ) : (
                  participation.canRegister && (
                    <section className={styles.btnWrapper}>
                      {participation.shouldShowAddGameButton && (
                        <div>
                          <div onClick={gameManagement.toggleMoreInfoModal}>
                            <Button active color='red' type='cupbottom'>
                              <FormattedMessage id='settings.games.addGame' />
                            </Button>
                          </div>
                          {!!gameManagement.openMoreInfoModal && (
                            <div className={styles.addGame}>
                              <input
                                icon='pencil'
                                name='nickname'
                                placeholder='In Game Nickname'
                                className={styles.addGameInput}
                                onChange={
                                  gameManagement.handleGameNicknameChange
                                }
                                value={gameManagement.gameNickname}
                              />
                              <button
                                className={styles.addGameInputButton}
                                onClick={gameManagement.addGame}
                              >
                                Add
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      {participation.shouldShowRegistrationButton &&
                        (participation.errorMessage ? (
                          <div onClick={showErrorToast}>
                            <Button active color='yellow' type='cupbottom'>
                              <FormattedMessage id='battlecup.information.registrationButton' />{' '}
                              *
                            </Button>
                          </div>
                        ) : (
                          <div onClick={handleRegistrationClick}>
                            <Button active color='yellow' type='cupbottom'>
                              <FormattedMessage id='battlecup.information.registrationButton' />
                            </Button>
                          </div>
                        ))}
                      {participation.shouldShowFillProfileButton && (
                        <div onClick={navigation.handleProfileSettingsClick}>
                          <Button active color='yellow' type='cupbottom'>
                            <FormattedMessage id='battlecup.information.fillProfile' />
                          </Button>
                        </div>
                      )}
                    </section>
                  )
                )
              ) : (
                <CircularProgress />
              )
            ) : (
              <div onClick={navigation.handleLoginClick}>
                <Button active color='red' type='cupbottom'>
                  <FormattedMessage id='navigation.login' />
                </Button>
              </div>
            )}
          </article>
        </div>
        <CupTab navList={navigation.navList} />
        {!!tournamentDoesnotExistModal && (
          <TournamentDoesnotExistModal
            tournamentDoesnotExistModal={tournamentDoesnotExistModal}
            userUrl={userData?.url}
          />
        )}
      </div>
    </>
  )
}

export default withRouter(Top)
